var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormMembersItem.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormMembersItem.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "isRequired", "isHead"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isRequired", Object.prototype.hasOwnProperty.call(kwargs, "isRequired") ? kwargs["isRequired"] : true);frame.set("isHead", Object.prototype.hasOwnProperty.call(kwargs, "isHead") ? kwargs["isHead"] : false);var t_5 = "";t_5 += "\n    <div class=\"SubmissionFormMembersItem\">\n        <div class=\"SubmissionFormElement-form SubmissionFormElement-form--border\">\n            ";
if(!runtime.contextOrFrameLookup(context, frame, "isHead")) {
t_5 += "\n                <div class=\"SubmissionFormMembersItem-collapse\">\n                    ";
t_5 += runtime.suppressValue((lineno = 7, colno = 42, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-dropdown","0 0 24 24",runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
t_5 += "\n                </div>\n            ";
;
}
t_5 += "\n\n            ";
var t_8;
t_8 = [["pd","Production Designer"],["sad","Supervising Art Director"],["snad","Senior Art Director"],["ad","Art Director"],["aad","Assistant Art Director"],["sbad","Standby Art Director"],["osad","On Set Art Director"],["vc","Visual Consultant"],["sds","Set Designer"],["dsm","Digital Set Designer"],["dm","Draughtsman"],["dmp","Draughtsperson"],["sdm","Senior Draughtsman"],["jdm","Junior Draughtsman"],["mm","Model Maker"],["ill","Illustrator"],["ma","Matte Artist"],["sba","Storyboard Artist"],["ca","Concept Artist"],["ci","Concept Illustrator"],["pa","Previs Artist"],["sca","Scenic Artist"],["ta","Title Artist"],["gd","Graphic Designer"],["ga","Graphic Artist"],["agd","Assistant Graphic Designer"],["sdc","Set Decorator"]];
frame.set("positions", t_8, true);
if(frame.topLevel) {
context.setVariable("positions", t_8);
}
if(frame.topLevel) {
context.addExport("positions", t_8);
}
t_5 += "\n\n            <h3 class=\"SubmissionFormElement-header SubmissionFormMembersItem-header\">Team Member</h3>\n            <h3 class=\"SubmissionFormElement-header SubmissionFormMembersItem-headerName\">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"name")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"name"), env.opts.autoescape);
;
}
t_5 += "</h3>\n            <div class=\"SubmissionFormMembersItem-position\">";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "positions");
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("item", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
t_5 += "\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"position") == runtime.memberLookup((t_12),0)) {
t_5 += runtime.suppressValue(runtime.memberLookup((t_12),1), env.opts.autoescape);
;
}
t_5 += "\n            ";
;
}
}
frame = frame.pop();
t_5 += "</div>\n\n            <input type=\"hidden\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " name=\"id\">\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">";
if(runtime.contextOrFrameLookup(context, frame, "isHead")) {
t_5 += "HEAD OF THE ART DEPARTMENT";
;
}
else {
t_5 += "POSITION";
;
}
t_5 += "</div>\n                <div class=\"SubmissionFormElement-inputWrapper SubmissionFormElement-inputWrapper--select\">\n                    <select name=\"position\" class=\"SubmissionFormElement-select\">\n                        <option disabled selected value class=\"SubmissionFormElement-select-optionDefault\"> -- select -- </option>\n                        ";
frame = frame.push();
var t_15 = runtime.contextOrFrameLookup(context, frame, "positions");
if(t_15) {t_15 = runtime.fromIterator(t_15);
var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("item", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
t_5 += "\n                            <option value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_16),0), env.opts.autoescape);
t_5 += "\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"position") == runtime.memberLookup((t_16),0) || (runtime.contextOrFrameLookup(context, frame, "isHead") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"position") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first"))) {
t_5 += "selected";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_16),1), env.opts.autoescape);
t_5 += "</option>\n                        ";
;
}
}
frame = frame.pop();
t_5 += "\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">NAME</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"name")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"name"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " name=\"name\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">DAYTIME PHONE</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"phone")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"phone"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"phone\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">EMAIL ADDRESS</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"email\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"email")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"email"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"email\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">ADDRESS</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"address")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"address"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"address\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName\">Address Line 2</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"address2")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"address2"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"address2\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">City/Town</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"city")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"city"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"city\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLineMerge\">\n                <div class=\"SubmissionFormElement-inputLine SubmissionFormElement-inputLine--input-left\">\n                    <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">State/province</div>\n                    <div class=\"SubmissionFormElement-inputWrapper\">\n                        <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"state")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"state"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                            name=\"state\" class=\"SubmissionFormElement-input\">\n                    </div>\n                </div>\n\n                <div class=\"SubmissionFormElement-inputLine SubmissionFormElement-inputLine--input-right\">\n                    <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">Zip/postal Code</div>\n                    <div class=\"SubmissionFormElement-inputWrapper\">\n                        <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"zip")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"zip"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                            name=\"zip\" class=\"SubmissionFormElement-input\">\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">Country</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"country")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"country"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"country\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">UNION AFFILIATION<br/>(800, 44, 829… None)</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"affiliation")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"affiliation"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"affiliation\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            ";
if(!runtime.contextOrFrameLookup(context, frame, "isHead")) {
t_5 += "\n                <div class=\"SubmissionFormMembersItem-delete\">\n                    Delete member\n                </div>\n            ";
;
}
t_5 += "\n        </div>\n\n        ";
if(!runtime.contextOrFrameLookup(context, frame, "isHead")) {
t_5 += "\n            <div class=\"SubmissionFormMembersItem-reorder\">\n                ";
t_5 += runtime.suppressValue((lineno = 150, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["reorder","0 0 14 10",runtime.makeKeywordArgs({"caller": (function (){var macro_t_17 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_18 = "";;
frame = frame.pop();
return new runtime.SafeString(t_18);
});
return macro_t_17;})()})])), env.opts.autoescape);
t_5 += "\n            </div>\n        ";
;
}
t_5 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("SubmissionFormMembersItem");
context.setVariable("SubmissionFormMembersItem", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormMembersItem.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormMembersItem.jinja
// module id = 23
// module chunks = 0